module.exports = __webpack_public_path__ + "img/cave164.3131f1b3.jpg";